import classNames from 'classnames';
import { CurrencyPairSwitcher } from 'components/shared/currency-pair-switcher';
import { CurrencyPairSwitcherMetadata } from 'models/forms/fields';
import { useCallback } from 'react';
import { ErrorWrapper } from 'routes/essential-workspace/components/form/error-wrapper';
import { useFormErrors } from 'routes/essential-workspace/components/form/use-form-errors';
import { useFormFieldData } from 'routes/essential-workspace/components/form/use-form-field-data';

export function CurrencyPairSwitcherField({
  id,
  translationKey,
  currency1,
  currency2,
  isReadOnly,
}: CurrencyPairSwitcherMetadata) {
  const [value, setFormData] = useFormFieldData<Nullable<string>>(id);

  const { getFieldError } = useFormErrors();
  const fieldError = getFieldError(id);

  const onToggleCurrency = useCallback(
    (newCurrency: string) => {
      setFormData(newCurrency);
    },
    [setFormData],
  );

  return (
    <ErrorWrapper error={fieldError}>
      <div
        className={classNames('input-group card bg-lvl1 h-100 px-3 pt-1 pb-3', {
          'card-bordering-primary': !isReadOnly,
          'border-bottom border-warning': fieldError?.severity === 'Error',
          'border-bottom border-info': fieldError?.severity === 'Warning',
        })}
      >
        <CurrencyPairSwitcher
          id={id}
          switchedCurrencyTranslationKey={translationKey}
          value={value}
          onToggleCurrency={onToggleCurrency}
          currency1={currency1}
          currency2={currency2}
        >
          <CurrencyPairSwitcher.Label isReadOnly={isReadOnly} />
          {!isReadOnly && <CurrencyPairSwitcher.Input />}
        </CurrencyPairSwitcher>
      </div>
    </ErrorWrapper>
  );
}
